// import firebase from "firebase/app";
// import firebase from "firebase"sss
// import firebase from 'firebase/compat/app';
import { notification } from 'antd';
import { initializeApp } from 'firebase/app';


import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { FaBell } from 'react-icons/fa';
const firebaseConfig = {
  apiKey: "AIzaSyCX5p9BuJFrdRnzgT9dNtj7dDsqxJ2U_lo",
  authDomain: "ossol-327014.firebaseapp.com",
  projectId: "ossol-327014",
  storageBucket: "ossol-327014.appspot.com",
  messagingSenderId: "985342973431",
  appId: "1:985342973431:web:322d15261a4446ceb74af2",
  measurementId: "G-8GLV512M54"
};
 
initializeApp(firebaseConfig); 
const messaging = getMessaging();
export const requestForToken = () => {
  return getToken(messaging, { vapidKey: "BH_zPQR70euKjLBahg4esbbX91dWPfOXcdz7emllTOInK_6ZpSHU6v5U_TT9yroRiF-jHNsCnePxMb26tXXuYtM" })
    .then((currentToken) => {
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        // Perform any other neccessary action with the token
        return currentToken;
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

export const onMessageListener = (onSuccessfcm) =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      // console.log("onMessageListener", payload)
      // 1 orders
      // 2 comments
      // ReferenceId
      notification.info({
        message: payload?.data?.TitleLT,
        description: payload?.data?.DescriptionLT,
        icon: <FaBell style={{ color: '#c2a062' }} />,
      });    
    onSuccessfcm(payload); 
    });
  });
